'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var SubscriptionPlanView = require('modules/settings/views/partials/subscription/plan');
var SubscriptionPaymentMethodView = require('modules/settings/views/partials/subscription/payment-method');
var SubscriptionBillingAddressView = require('modules/settings/views/partials/subscription/billing-address');
var SubscriptionTaxCountryView = require('modules/settings/views/partials/subscription/tax-country');
var Html = require('base/Colido.Html');

var template = require('modules/settings/templates/layout/subscription/setup.hbs');

var SubscriptionSetupLayout = LayoutView.extend({
    template: template,

    className: 'subscription-setup',

    ui: {
        scrollContainer: '.scroll-container',
        nextButton: '[data-action="next-step"]',
        voucherButton: '[data-action="enter-voucher-code"]',
    },

    events: {
        'click @ui.nextButton': 'requestNextStep',
        'click @ui.voucherButton': 'onClickVoucherButton',
        'click h2': 'render',
    },

    regions: {
        planDisplayRegion: '.subscription-details-plan-display-region',
        paymentMethodDisplayRegion: '.subscription-details-payment-method-display-region',
        billingAddressDisplayRegion: '.subscription-details-billing-address-display-region',
        residencyCountryDisplayRegion: '.subscription-details-residency-country-display-region',
        editRegion: '.subscription-details-edit-region',
    },

    modelEvents: {
        'change': 'render',
    },

    childEvents: {
        'readyToSave': 'updateNextButton',
        'revokeReadyToSave': 'disableNextButton',
        'saved': 'setNextStep',
        'saving': 'showSaveButtonLoader',
        'save:error': 'handleSaveError',
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.model = this.getOption('subscriptionModel');
    },

    onRender: function() {
        var step = this.model.get('setupStep');

        this.updateNextButton();
        this.ui.nextButton.prop('disabled', true);

        // Display views
        if (step > 0) {
            this.planDisplayRegion.show(new SubscriptionPlanView({
                isSetup: true,
                model: this.model,
            }));
        }

        if (step > 1) {
            this.paymentMethodDisplayRegion.show(new SubscriptionPaymentMethodView({
                isSetup: true,
                model: this.model,
            }));
        }

        if (step > 2) {
            this.billingAddressDisplayRegion.show(new SubscriptionBillingAddressView({
                isSetup: true,
                model: this.model,
            }));
        }

        if (step > 3) {
            this.residencyCountryDisplayRegion.show(new SubscriptionTaxCountryView({
                isSetup: true,
                model: this.model,
            }));
        }

        // Edit views
        if (step === 0) {
            this.editRegion.show(new SubscriptionPlanView({
                mode: 'edit',
                isSetup: true,
                model: this.model,
            }));
        }

        if (step === 1) {
            this.editRegion.show(new SubscriptionPaymentMethodView({
                mode: 'edit',
                isSetup: true,
                model: this.model,
            }));
        }

        if (step === 2) {
            this.editRegion.show(new SubscriptionBillingAddressView({
                mode: 'edit',
                isSetup: true,
                model: this.model,
            }));
        }

        if (step === 3 && this.model.get('taxCountryMatches') < 2) {
            this.editRegion.show(new SubscriptionTaxCountryView({
                mode: 'edit',
                isSetup: true,
                model: this.model,
            }));
        }

        if (this.isReadyToPay()) {
            this.ui.nextButton.prop('disabled', false).removeClass('is-loading');
        }

        // Scroll to last container
        if (this.$('.container:last-child').length) {
            var lastContainerPosition = this.$('.container:last-child').position();
            this.ui.scrollContainer.animate({scrollTop: Math.round(lastContainerPosition.top - this.getPxSize(10))}, 400);
        }
    },

    requestNextStep: function(event) {
        if (this.editRegion.hasView()) {
            this.editRegion.currentView.triggerMethod('submit');
        } else {
            this.activateSubscription();
        }
    },

    //called if child view triggers saved event
    setNextStep: function(event) {
    },

    updateNextButton: function(view, data) {
        var labelPay = Html.icon('lock') + App.t('subscription::setup:button:pay-amount', {
            amount: Html.formatCurrency(this.model.get('sumAmountTotal'), this.model.get('currency')),
        });

        var labelsForSteps = [
            App.t('subscription::setup:button:proceed-to-payment'),
            App.t('subscription::setup:button:proceed-to-billing-address'),
            App.t('subscription::setup:button:proceed-to-checkout'),
            this.isReadyToPay() ? labelPay : App.t('subscription::setup:button:proceed-checkout'),
            labelPay,
        ];

        this.ui.nextButton.prop('disabled', false).removeClass('is-loading');
        var nextButtonLabel = data && data.nextButtonLabel ? data.nextButtonLabel : labelsForSteps[this.model.get('setupStep')];
        this.ui.nextButton.html(nextButtonLabel).toggleClass('is-pay', this.isReadyToPay());
    },

    /**
     * Disables the next button
     */
    disableNextButton: function() {
        this.ui.nextButton.prop('disabled', true).removeClass('is-loading');
    },

    activateSubscription: function(event) {
        this.showSaveButtonLoader();

        this.model.save({
            subscriptionActive: true,
        }, {
            patch: true,
            wait: true,
            success: function(model) {
                App.user.fetch(); // Refetch user
                App.router.navigate('/account/subscription', {trigger: true});
            }.bind(this),
            error: function(model, response) {
                this.handleSaveError(this, response);
            }.bind(this),
        });
    },

    /**
     * Checks, if the subscription is ready to save
     * @returns {boolean} True, if subscription could be saved
     */
    isReadyToPay: function() {
        var step = this.model.get('setupStep');

        return (step === 3 && this.model.get('taxCountryMatches') > 1) || step === 4;
    },

    /**
     * Shows loader on the proceed button
     */
    showSaveButtonLoader: function() {
        this.ui.nextButton.prop('disabled', true).addClass('is-loading');
    },

    /**
     * Handles the error in a subview
     * @param {object}  childView The childview that triggered the error
     * @param {object=} response  (Optional) The error response
     */
    handleSaveError: function(childView, response) {
        this.ui.nextButton.prop('disabled', false).removeClass('is-loading');

        var errorObject = response && response.responseJSON && response.responseJSON.error;
        if (!errorObject) {
            var message = Messenger().error({
                message: App.t('subscription::setup:message:error-checkout-process'),
                actions: {
                    try: {
                        label: App.t('subscription::setup:button:try-again'),
                        action: function() {
                            this.requestNextStep();
                            message.hide();
                        }.bind(this),
                    },
                },
            });
        }
    },

    /**
     * Is triggered, when the enter voucher code button is clicked
     */
    onClickVoucherButton: function() {
        this.planDisplayRegion.currentView.triggerMethod('open:voucher:modal');
    },
});

module.exports = SubscriptionSetupLayout;